<template>
    <div class="toc">
        <template v-for="chapter of filtered">
            <div v-if="chapter.type === 'project'" class="unit" :key="chapter.id">
                <div class="unit-header flex flex-align">
                    <div class="title resource-color-label " :class="chapter.metadata.color === 'none' ? '' : chapter.metadata.color">{{chapter.title}}</div>
                </div>
                <div class="children">
                    <toc :children="chapter.children" :search="search" />
                </div>
            </div>
            <div v-else-if="chapter.type === 'unit'" class="section" :key="chapter.id">
                <div class="section-header flex flex-align">
                    <div class="number">{{chapter.metadata.chapter}}</div>
                    <div class="title resource-color-label " :class="chapter.metadata.color === 'none' ? '' : chapter.metadata.color">{{chapter.title}}</div>
                    <div class="ff"></div>
                    <div class="pacing" v-if="chapter.metadata.pacing">{{chapter.metadata.pacing}}</div>
                </div>
                <div class="children">
                    <toc :children="chapter.children" :search="search" />
                </div>
            </div>
            <div class="flex flex-align chapter" v-else :style="{'margin-left': (50 * ((chapter.metadata.indent || 1) - 1)) + 'px'}" :key="chapter.id">
                <div class="number">{{chapter.metadata.chapter || '—'}}</div>
                <router-link class="title resource-color-label " :class="chapter.metadata.color === 'none' ? '' : chapter.metadata.color" :to="{name: 'resource', params: {unit: chapter.parent.id, resource: chapter.id}}">{{chapter.title}}</router-link>
                <div class="ff"></div>
                <div class="pacing" v-if="chapter.metadata.pacing">{{chapter.metadata.pacing}}</div>
                <!-- <a class="text-button" @click="assign(chapter)" v-if="chapter.chapter_questions">Assign</a> -->
                <!-- <div class="questions-icon" :class="{active: chapter.chapter_questions}" v-tooltip="'This chapter contains assessment questions.'"></div>
                <div class="simulations-icon" :class="{active: chapter.chapter_simulations}" v-tooltip="'This chapter contains simulations.'"></div> -->
            </div>
        </template>
    </div>
</template>

<script>
    export default {
        name: 'TOC',
        props: {
            children: Array,
            search: String
        },
        computed: {
            filtered(){
                if(this.children){
                    return this.children.filter(chapter => this.matches(chapter));
                }

                return [];
            },
            product(){
                return this.$store.getters.product;
            }
        },
        methods: {
            matches(chapter){
                if(this.search){
                    if(chapter.title.toLowerCase().includes(this.search)){
                        return true;
                    }

                    if(chapter.children){
                        return chapter.children.find(child => this.matches(child));
                    }

                    return false;
                }

                return true;
            },
            highlight(title){
                if(this.search){
                    return title.replace(this.search, `<span class="highlight">${this.search}</span>`);
                }

                return title;
            }
        }
    }
</script>

<style scoped lang="less">
    @import "~@/assets/less/variables";

    @unit-font-size: 18px;
    @section-font-size: 24px;
    @number-width: 40px;

    .toc
    {

    }

    .title
    {
        font-size: 15px;
        color: var(--primary-text-color);
    }

    .children
    {
        padding-left: @number-width;
        padding-top: 20px;
    }

    .number
    {
        width: @number-width;
        font-size: 15px;
        color: var(--secondary-text-color);
        position: absolute;
        left: -1 * @number-width;
        top: 0;
    }

    .unit
    {
        padding: 50px 0 30px;
        // border-top: 1px solid fade(@base, 25%);

        > .children
        {
            padding-left: 0;
            padding-top: 10px;
        }
    }

    .unit-header
    {
        .title
        {
            color: @base;
            font-size: 14px;
            font-weight: 600;
            line-height: 32px;
            padding: 0 15px;
            border-radius: 32px;
            background: fade(@base, 15%);
        }
    }

    .section
    {
        padding: 25px 0;
        // border-top: 1px solid var(--border-color);

        &:first-child
        {
            border-top: 0;
        }
    }

    .section-header
    {
        .title, .number
        {
            font-size: @section-font-size;
            font-weight: 600;
            line-height: 30px;
        }
    }

    .chapter
    {
        padding: 4px 0;
        line-height: 24px;

        .number
        {
            top: 4px;
        }

        .title
        {
            cursor: pointer;

            &::after
            {
                content: "";
                position: absolute;
                border-bottom: 1px solid var(--secondary-text-color);
                top: 0;
                left: 0;
                bottom: -2px;
                pointer-events: none;
                width: 0;
                transition: width ease 0.2s;
            }

            &:hover, &:active
            {
                &::after
                {
                    width: 100%;
                }
            }
        }

        .questions-icon, .simulations-icon
        {
            width: 24px;
            height: 24px;
            min-width: 24px;
            opacity: 0.2;
            pointer-events: none;

            &.active
            {
                opacity: 1;
                pointer-events: all;
            }
        }

        .questions-icon
        {
            background: url('~@/assets/icons/grey/questions.svg') 5px 7px no-repeat;
            background-size: 14px auto;
        }

        .simulations-icon
        {
            background: url('~@/assets/icons/grey/simulations.svg') 2px 7px no-repeat;
            background-size: 22px auto;
        }

        .text-button
        {
            margin: 0 10px;
            font-size: 15px;
            font-weight: 400;
            line-height: 24px;
            height: 24px;
        }

        &:hover
        {
            .pacing
            {
                background: darken(@grey, 20%);
            }
        }
    }

    .pacing
    {
        background: @grey;
        color: @f;
        line-height: 18px;
        height: 18px;
        border-radius: 3px;
        font-size: 12px;
        font-weight: 600;
        padding: 0 4px;
        letter-spacing: -0.01rem;
        transition: background-color ease 0.2s;
        flex-shrink: 0;
        margin-left: 20px;
    }

    @media only screen and (max-width: 1100px)
    {
        .section-header
        {
            .number
            {
                position: relative;
                left: 0;
            }
        }

        .children
        {
            padding-top: 10px;
        }
    }

    .resource-color-label {
        &.green
        {
            color: @green-text;
        }

        &.blue
        {
            color: @blue-text;
        }
        &.gold
        {
            color: @gold-text;
        }

        &.magenta
        {
            color: @magenta-text;
        }

        &.red
        {
            color: @red;
        }

        &.orange
        {
            color: @orange;
        }

        &.yellow
        {
            color: @yellow;
        }
    }
</style>
